import { GeoLocations } from './actionTypes';

const initialState = {
    initial: true,
    isFetching: false,
    geoLocations: [],
    isGeoLocating: false,
    geoLocated: false,
    geoLocationPosition: [],
    isFetchingGeoLocationByIP: false,
    geoLocatedByIP: false,
    geoLocationByIP: {},
};

const requestGeoLocations = (state) => {
    return {
        ...state,
        initial: false,
        isFetching: true,
    };
};

const receiveGeoLocations = (state, { geoLocations }) => {
    return {
        ...state,
        isFetching: false,
        geoLocations,
    };
};

const requestGeoLocationPosition = (state) => {
    return {
        ...state,
        isGeoLocating: true,
    };
};

const receiveGeoLocationPosition = (state, { geoLocationPosition }) => {
    return {
        ...state,
        geoLocated: true,
        isGeoLocating: false,
        geoLocationPosition,
    };
};

const requestGeoLocationByIP = (state) => {
    return {
        ...state,
        isFetchingGeoLocationByIP: true,
    };
};

const receiveGeoLocationByIP = (state, { geoLocationByIP }) => {
    return {
        ...state,
        geoLocatedByIP: true,
        isFetchingGeoLocationByIP: false,
        geoLocationByIP,
    };
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GeoLocations.REQUEST_GEO_LOCATIONS:
            return requestGeoLocations(state);
        case GeoLocations.RECEIVE_GEO_LOCATIONS:
            return receiveGeoLocations(state, action);
        case GeoLocations.REQUEST_GEO_LOCATION_POSITION:
            return requestGeoLocationPosition(state);
        case GeoLocations.RECEIVE_GEO_LOCATION_POSITION:
            return receiveGeoLocationPosition(state, action);
        case GeoLocations.REQUEST_GEO_LOCATION_BY_IP:
            return requestGeoLocationByIP(state);
        case GeoLocations.RECEIVE_GEO_LOCATION_BY_IP:
            return receiveGeoLocationByIP(state, action);
    }
    return state;
}
